import PageTabs from "@/components/PageTabs/PageTabs";
import { useNavigate } from "react-router-dom";
import styles from "./PackagingDetails.module.scss";
import usePackagingDetailTabs from "@/pages/packaging/detail/usePackagingDetailTabs";

export default function PackagingDetailTabs({ packagingId }: { packagingId: number }) {
  const navigate = useNavigate();

  const { tabs, activeTab } = usePackagingDetailTabs({ packagingId: packagingId });

  const onChange = (key: string) => {
    navigate(
      {
        pathname: `/packaging/${packagingId}/${key}`,
      },
      { replace: true }
    );
  };

  return (
    <PageTabs
      noLine={true}
      activeKey={activeTab}
      items={tabs}
      onChange={onChange}
      className={styles.pagetabs}
    />
  );
}
